import {Inject, Injectable} from '@angular/core';
import {WINDOW} from '@ng-web-apis/common';
import {DOCUMENT} from '@angular/common';
import {environment} from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleAdsService {
  private readonly clientId = environment.clientConfig.googleAdsClientId;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(WINDOW)
    private readonly window: Window & {
      adsbygoogle: unknown[] & {
        pauseAdRequests: number;
        requestNonPersonalizedAds: number;
      };
    },
  ) {}

  get adsByGoogle(): unknown[] & {
    pauseAdRequests: number;
    requestNonPersonalizedAds: number;
  } {
    this.window.adsbygoogle = this.window.adsbygoogle || [];

    return this.window.adsbygoogle;
  }

  addGoogleAdsScript(): void {
    if (!this.clientId) {
      return;
    }

    const script = this.document.createElement('script');

    script.crossOrigin = 'anonymous';
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${this.clientId}`;
    this.document.head.appendChild(script);
  }

  pauseAds(): void {
    this.adsByGoogle.pauseAdRequests = 1;
  }

  requestNonPersonalizedAds(): void {
    this.adsByGoogle.requestNonPersonalizedAds = 1;
  }

  startAds(): void {
    this.adsByGoogle.pauseAdRequests = 0;
  }
}
